import { ChevronDown } from "lucide-react";
import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@porchpass/ui";
import type { DomainTaskStatusType } from "@porchpass/api-client";
import { formatStatusLabel } from "../../utils";
import { CONDITION_STATUSES } from "./conditionStatusOptions";

export const STATUS_STYLES: Record<DomainTaskStatusType, string> = {
  not_done: "bg-white text-[#4A5466] border-[#D3D5DB]",
  in_progress: "bg-[#E5EBFD] text-[#1453F5] border-[#1453F5]",
  in_review: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  done: "bg-[#E6F7EE] text-[#1A7F4B] border-[#B8E6CF]",
  cancelled: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]",
  correction_needed: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]",
};

interface ConditionStatusDropdownProps {
  status: DomainTaskStatusType;
  onStatusChange: (status: DomainTaskStatusType) => void;
  triggerClassName?: string;
  label: string;
}

export function ConditionStatusDropdown({
  status,
  onStatusChange,
  triggerClassName = "",
  label,
}: ConditionStatusDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          size="xs"
          className={cn(
            "h-auto shrink-0 border px-3 py-1 text-xs font-medium",
            triggerClassName,
          )}
        >
          {label}
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {CONDITION_STATUSES.map((option) => (
          <DropdownMenuItem
            key={option}
            onClick={() => onStatusChange(option)}
            className={option === status ? "font-semibold" : ""}
          >
            {formatStatusLabel(option)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
